export default "__VITE_ASSET__DENF_cLY__"